

module.exports = angular.module;


//////////////////
// WEBPACK FOOTER
// ../node_modules/squid/dist/module.js
// module id = ../node_modules/squid/dist/module.js
// module chunks = 0